export { createEmojiPlugin } from './plugin/createEmojiPlugin';
export { EmojiStringKeys } from './type/EmojiStringKeys';
